import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=5fc1b240&scoped=true&"
import script from "./UserDetails.vue?vue&type=script&lang=ts&"
export * from "./UserDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=5fc1b240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1b240",
  null
  
)

export default component.exports